import React, { useState, useEffect,useRef } from 'react';
import { Menu, X, Phone, Mail, Clock, Wrench,Scissors, Home, AlertCircle, Zap, Star, Award, Shield, Calculator, Search,Truck, ArrowLeft, Package, CloudRain, ChevronRight, ArrowRight, Users, Building, CheckCircle, TrendingUp, ChevronLeft, Grid, List, ShoppingCart, HardHat, PaintBucket, Droplets, Thermometer, Layers, Send, Calendar, DollarSign, Bath, Target, Hammer, Handshake, Cpu, Microscope, Quote, MapPin} from 'lucide-react';

import { Trabajo, Producto, Servicio, PhoneNumber } from '../types';
import { apiCall, API_BASE_URL, formatPrecio, useScrollAnimation } from '../utils';
import PhoneSelector from '../components/PhoneSelector';
// ==================== HOME PAGE PROFESIONAL ====================
export default function HomePage({ navigateToPage }: { navigateToPage: (page: string) => void }) {
  useScrollAnimation();
  const [showPhoneSelector, setShowPhoneSelector] = useState(false);

  const currentYear = new Date().getFullYear();
  const yearsOfExperience = currentYear - 1998;

  const stats = [
    { value: `+${yearsOfExperience}`, label: "Años de Experiencia", icon: Award },
    { value: "+5000", label: "Proyectos Realizados", icon: Building },
  ];


  return (
    <div>
      <PhoneSelector 
        isOpen={showPhoneSelector} 
        onClose={() => setShowPhoneSelector(false)} 
      />

      {/* Hero Section Moderna */}
      <section className="relative min-h-screen flex items-center bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 overflow-hidden">
        {/* Patrón de fondo */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }} />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="text-white space-y-8">
              <div className="space-y-5">
                <div className="flex items-center gap-3">
                  <div className="h-[2px] w-10 bg-blue-400"></div>
                  <span className="text-sm font-semibold text-blue-300 uppercase tracking-widest">
                    Empresa de construcción · Martos, Jaén
                  </span>
                </div>

                <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight">
                  Construimos el
                  <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">
                    Futuro Juntos
                  </span>
                </h1>

                <p className="text-xl text-gray-300 max-w-xl">
                  Más de {yearsOfExperience} años transformando ideas en realidad. Expertos en reformas integrales, construcción y servicios del hogar.
                </p>
              </div>

              {/* Garantías reales */}
              <ul className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-gray-200">
                <li className="flex items-center gap-2">
                  <CheckCircle className="h-4 w-4 text-blue-400 flex-shrink-0" aria-hidden="true" />
                  Presupuesto cerrado sin sorpresas
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle className="h-4 w-4 text-blue-400 flex-shrink-0" aria-hidden="true" />
                  Garantía por escrito
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle className="h-4 w-4 text-blue-400 flex-shrink-0" aria-hidden="true" />
                  Financiación flexible
                </li>
              </ul>

              <div className="flex flex-col sm:flex-row gap-4">
                <button
                  onClick={() => navigateToPage('contacto')}
                  className="group bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-all duration-300 shadow-xl hover:shadow-2xl flex items-center justify-center"
                >
                  Pedir presupuesto sin compromiso
                  <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                </button>
                <button
                  onClick={() => navigateToPage('proyectos')}
                  className="bg-white/10 backdrop-blur text-white border border-white/30 px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-all duration-300"
                >
                  Ver proyectos realizados
                </button>
              </div>

              {/* Mini stats */}
              <div className="grid grid-cols-2 gap-6 pt-8 border-t border-white/20">
                {stats.map((stat, index) => (
                  <div key={index}>
                    <p className="text-3xl font-bold text-white">{stat.value}</p>
                    <p className="text-sm text-gray-400">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Imagen decorativa */}
            <div className="relative hidden lg:block scroll-animate" style={{ animationDelay: '0.3s' }}>
              <div className="relative z-10 group">
                <div className="absolute -inset-4 bg-gradient-to-r from-blue-600 to-cyan-500 rounded-[2.5rem] blur-xl opacity-20 group-hover:opacity-40 transition duration-1000 group-hover:duration-200"></div>
                <img
                  src="https://images.unsplash.com/photo-1600607686527-6fb886090705?w=800"
                  alt="Reformas y Construcción de Alta Calidad"
                  fetchPriority="high"
                  decoding="async"
                  width={800}
                  height={550}
                  className="relative rounded-[2rem] shadow-2xl object-cover h-[550px] w-full border border-white/10"
                />
                
                {/* Badge de contacto flotante cristalino */}
                <div 
                  onClick={() => setShowPhoneSelector(true)}
                  className="absolute -bottom-8 -right-8 bg-white/10 backdrop-blur-xl border border-white/20 p-6 rounded-2xl shadow-[0_8px_32px_0_rgba(31,38,135,0.37)] cursor-pointer hover:bg-white/20 hover:-translate-y-1 transition-all duration-300"
                >
                  <div className="flex items-center gap-4">
                    <div className="bg-blue-500/80 p-4 rounded-full shadow-lg">
                      <Phone className="h-6 w-6 text-white" />
                    </div>
                    <div>
                      <p className="text-white/80 text-sm font-medium">¿Comenzamos tu proyecto?</p>
                      <p className="text-white font-bold text-xl">Llamar Ahora</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Indicador de scroll */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
            <div className="w-1 h-3 bg-white/50 rounded-full mt-2"></div>
          </div>
        </div>
      </section>

      {/* Sección de Servicios Mejorada */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 scroll-animate">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Algunos De Nuestros Servicios
            </h2> 
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Ofrecemos soluciones integrales con la máxima calidad y garantía
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {[
              { id: 'desatranques', img: '/imagenes/servicios/desatranques.png', titulo: 'Desatranques', desc: 'Servicio rápido y eficaz para solucionar atascos en tuberías y desagües, sin obras.' },
              { id: 'carpinteria-metalica', img: '/imagenes/servicios/carpinteria_metalica.png', titulo: 'Carpintería Metálica', desc: 'Ventanas, puertas y cerramientos de aluminio con rotura de puente térmico.' },
              { id: 'piscinas', img: '/imagenes/servicios/piscinas.png', titulo: 'Piscinas', desc: 'Construcción de piscinas de obra a medida y reforma de piscinas existentes.' },
              { id: 'fontaneria', img: '/imagenes/servicios/fontaneria.png', titulo: 'Fontanería', desc: 'Instalaciones nuevas, reparación de averías y detección de fugas sin romper.' },
              { id: 'electricidad', img: '/imagenes/servicios/electricidad.png', titulo: 'Electricidad', desc: 'Instalaciones eléctricas certificadas por instaladores autorizados.' },
              { id: 'descalcificadores', img: '/imagenes/servicios/osmosis.png', titulo: 'Descalcificadores y Ósmosis', desc: 'Sistemas de tratamiento de agua: eliminan la cal y mejoran el agua de tu hogar.' }
            ].map((servicio, index) => (
              <div
                key={servicio.id}
                className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500 scroll-animate card-hover"
                style={{ animationDelay: `${0.1 * (index + 1)}s` }}
              >
                <div className="absolute inset-0">
                  <img
                    src={servicio.img}
                    alt={servicio.titulo}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-transparent" />
                </div>
                <div className="relative p-6 h-[320px] flex flex-col justify-end text-white">
                  <h3 className="text-xl font-bold mb-2">{servicio.titulo}</h3>
                  <p className="text-gray-200 text-sm mb-4">{servicio.desc}</p>
                  <button
                    onClick={() => {
                      navigateToPage('servicios');
                      setTimeout(() => {
                        const event = new CustomEvent('selectServicio', { detail: servicio.id });
                        window.dispatchEvent(event);
                      }, 100);
                    }}
                    className="inline-flex items-center text-white font-semibold hover:text-blue-400 transition-colors text-sm"
                    aria-label={`Más información sobre ${servicio.titulo}`}
                  >
                    Más información
                    <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <button
              onClick={() => navigateToPage('servicios')}
              className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-all duration-300 shadow-xl hover:shadow-2xl"
            >
              Ver Todos los Servicios
            </button>
          </div>
        </div>
      </section>

      {/* Nueva Sección: Nuestra Historia */}
      {/* NOTA: La sección "Cómo Trabajamos" está guardada en components/ComoTrabajamos.tsx por si se quiere activar en el futuro */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="scroll-animate">
              <div className="flex items-center gap-3 mb-6">
                <div className="h-[2px] w-12 bg-blue-600"></div>
                <span className="text-sm font-bold text-blue-600 uppercase tracking-widest">Nuestra Historia</span>
              </div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                {new Date().getFullYear() - 1998} Años Construyendo <span className="gradient-text">Confianza</span>
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                Desde 1998, José Luis Construcciones ha sido sinónimo de calidad y profesionalidad en Jaén. 
                Todo comenzó con una visión clara: ofrecer servicios de construcción y reformas que superaran 
                las expectativas de nuestros clientes.
              </p>
              <p className="text-gray-600 mb-8">
                Nuestro compromiso con la excelencia y la satisfacción del cliente nos ha permitido crecer 
                y evolucionar, manteniendo siempre los valores que nos caracterizan: honestidad, calidad y 
                atención personalizada.
              </p>
              <div className="grid grid-cols-2 gap-6">
                <div className="bg-white p-6 rounded-xl shadow-lg">
                  <Zap className="h-10 w-10 text-blue-600 mb-3" />
                  <h3 className="font-bold text-gray-900 mb-2">Innovación Constante</h3>
                  <p className="text-sm text-gray-600">
                    Siempre con las mejores técnicas y materiales del mercado
                  </p>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-lg">
                  <Handshake className="h-10 w-10 text-blue-600 mb-3" />
                  <h3 className="font-bold text-gray-900 mb-2">Compromiso Total</h3>
                  <p className="text-sm text-gray-600">
                    Cada proyecto es único y lo tratamos con la máxima dedicación
                  </p>
                </div>
              </div>
            </div>
            <div className="scroll-animate" style={{ animationDelay: '0.2s' }}>
              <div className="space-y-6">
                {/* Timeline */}
                {[
                  { year: '1998', title: 'Fundación', desc: 'Nace José Luis Construcciones en Martos, Jaén, con una clara vocación de servicio y calidad.', icon: 'building' },
                  { year: '2005', title: 'Expansión', desc: 'Ampliamos nuestra actividad a toda la provincia de Jaén, consolidándonos como referente en reformas integrales.', icon: 'trending' },
                  { year: '2015', title: 'Innovación', desc: 'Incorporamos las últimas tecnologías y materiales del mercado para ofrecer acabados de primera.', icon: 'zap' },
                  { year: 'Hoy', title: '+5000 Proyectos', desc: 'Seguimos creciendo con el mismo compromiso del primer día, respaldados por miles de clientes satisfechos.', icon: 'award' },
                ].map((item, index) => (
                  <div key={index} className="flex gap-5 group">
                    <div className="flex flex-col items-center">
                      <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center text-white shadow-lg shadow-blue-500/25 group-hover:scale-110 transition-transform duration-300">
                        <span className="text-sm font-black">{item.year}</span>
                      </div>
                      {index < 3 && <div className="w-[2px] h-full min-h-[20px] bg-gradient-to-b from-blue-300 to-transparent mt-2"></div>}
                    </div>
                    <div className="bg-white rounded-xl p-5 shadow-md border border-gray-100 flex-1 group-hover:shadow-lg group-hover:border-blue-100 transition-all duration-300">
                      <h4 className="font-bold text-gray-900 text-lg mb-1">{item.title}</h4>
                      <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sección Por Qué Elegirnos Mejorada */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16 scroll-animate">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              ¿Por Qué <span className="gradient-text">Elegirnos</span>?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              La confianza de nuestros clientes nos respalda. Siempre comprometidos con la calidad y la excelencia.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: <Shield className="h-12 w-12" />,
                title: "Garantía Total",
                description: "En todos nuestros materiales y trabajos realizados, con respaldo por escrito"
              },
              {
                icon: <Award className="h-12 w-12" />,
                title: `${yearsOfExperience} Años de Experiencia`,
                description: "Casi tres décadas de trayectoria reformando hogares en Jaén"
              },
              {
                icon: <Users className="h-12 w-12" />,
                title: "Equipo Profesional",
                description: "Personal altamente cualificado y en formación continua para ofrecer las mejores soluciones"
              },
              {
                icon: <Calculator className="h-12 w-12" />,
                title: "Financiación flexible",
                description: "Financiamos tus reformas a tu gusto y alcance"
              },
              {
                icon: <Clock className="h-12 w-12" />,
                title: "Cumplimiento de Plazos",
                description: "Respetamos los tiempos acordados sin comprometer la calidad del trabajo"
              },
              {
                icon: <TrendingUp className="h-12 w-12" />,
                title: "Presupuesto sin Compromiso",
                description: "Valoración gratuita y detallada de tu proyecto"
              }
            ].map((item, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-2xl border border-gray-200 shadow-sm hover:shadow-xl hover:border-blue-200 transition-all duration-300 scroll-animate group"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="text-blue-600 mb-6 group-hover:scale-110 transition-transform duration-300">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            ¿Listo para empezar tu proyecto?
          </h2>
          <p className="text-xl mb-8 text-blue-100">
            Contacta con nosotros y te asesoraremos sin compromiso
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigateToPage('contacto')}
              className="bg-white text-blue-600 px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-all duration-300 shadow-xl hover:shadow-2xl"
            >
              Solicitar Presupuesto
            </button>
            <button
              onClick={() => setShowPhoneSelector(true)}
              className="border-2 border-white text-white px-8 py-4 rounded-lg font-bold hover:bg-white hover:text-blue-600 transition-all duration-300"
            >
              <Phone className="inline mr-2" />
              Llamar Ahora
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}


// Datos detallados de servicios con imágenes más realistas
export const serviciosDetallados = [
  {
    id: "reformas-integrales",
    titulo: "Reformas Integrales",
    descripcion: "Transformamos completamente tu hogar o local. Desde la planificación hasta la ejecución, cuidando cada detalle para que tu espacio sea único y funcional.",
    descripcionLarga: `
                      <p>En José Luis Construcciones nos encargamos de todo el proceso, desde el diseño inicial hasta la entrega final.</p>
                      <p>Nuestro equipo de profesionales se encarga de gestionar todos los aspectos de la reforma: demolición, albañilería, fontanería, electricidad, carpintería, pintura, acabados finales, etc. Trabajamos con los mejores materiales del mercado y garantizamos plazos de entrega.</p>
                      `,
    imagen: "https://images.unsplash.com/photo-1484154218962-a197022b5858?w=800",
    imagenHero: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1200",
    serviciosIncluidos: [
      "Proyecto personalizado",
      "Garantía total",
      "Albañilería",
      "Instalaciones de agua, luz y gas certificadas",
      "Revestimientos",
      "Carpintería interior y exterior a medida",
      "Fabricacion de ventanas de alumunio a medida",
      "Pintura",
      "Limpieza final profesional de obra",
      "Garantía total del trabajo por escrito"
    ],
    puntosClave: [
      "Presupuesto cerrado sin sorpresas",
      `${new Date().getFullYear() - 1998} años de experiencia`,
      "Financiación flexible",
    ],
    categoriaTrabajo: "reforma_integral"
  },
  {
    id: "pintura",
    titulo: "Pintura y Diseño", 
    descripcion: "Renovamos tus espacios con los mejores acabados de alta calidad y durabilidad.",
    descripcionLarga: "Trabajamos con pintura profesional para interiores y exteriores, utilizando marcas reconocidas como Duracolor. Ofreciendo un asesoramiento personalizado y gratuito para la elección de colores y acabados que mejor se adapten a tu estilo y necesidades.",
    imagen: "/imagenes/servicios/foto_pintura.png",
    imagenHero: "https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=1200",
    serviciosIncluidos: [
      "Pintura interior de paredes y techos",
      "Pintura exterior de fachadas", 
      "Empapelado",
      "Alisado y preparación profesional de paredes",
      "Lacado de puertas, ventanas y muebles",
      "Asesoramiento gratuito en color y diseño",
      "Protección total de mobiliario y suelos",
    ],
    puntosClave: [
      "Trabajo limpio",
      "Pinturas sin olor",
      "Durabilidad garantizada",
      "Estilo personalizado"
    ],
    categoriaTrabajo: "fachada"
  },
  {
    id: "reformas-banos-cocinas",
    titulo: "Reformas de Baños y Cocinas",
    descripcion: "Especialistas en renovación de baños y cocinas. Diseños modernos y funcionales adaptados a tu espacio y presupuesto.",
    descripcionLarga: "Creamos baños y cocinas que combinan diseño, funcionalidad y calidad. Nuestro equipo se encarga de todo el proceso fontanería, electricidad, alicatados, mobiliario e instalación de electrodomésticos, etc",
    imagen: "/imagenes/servicios/foto_cocina.png",
    imagenHero: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=1200",
    serviciosIncluidos: [
      "Cambio de bañeras por platos de ducha",
      "Muebles de baño y cocina a medida",
      "Alicatados y solados",
      "Fontanería y saneamiento completo",
      "Instalación de luminarias",
      "Griferías",
      "Mamparas de cristal templado",
      "Ventilación y extractores"
    ],
    puntosClave: [
      "Diseño a tu gusto",
      "Garantía en las instalaciones",
      "Sin obra en el resto de la casa"
    ],
    categoriaTrabajo: "baño"
  },
  {
    id: "desatranques",
    titulo: "Desatranques",
    descripcion: "Servicio rápido y eficaz para solucionar problemas de atascos en tuberías y desagües.",
    descripcionLarga: `
                      <p>Servicio profesional de desatranques. Disponemos de tecnología como: cámaras de inspección HD, equipos de alta presión, excavadora.</p>
                      <p>Solucionamos sus desatranques sin necesidad de realizar obra, ahorrando tiempo y dinero.</p>
                      `,
    imagen: "/imagenes/servicios/desatranques.png",
    imagenHero: "https://images.unsplash.com/photo-1585704032915-c3400ca199e7?w=1200",
    serviciosIncluidos: [
      "Desatranque de tuberías con alta presión",
      "Inspección con cámara",
      "Localización exacta sin romper paredes",
      "Limpieza de arquetas y pozos",
      "Desatasco de bajantes comunitarias",
    ],
    puntosClave: [
      "Sin obras ni roturas",
      "Tecnología de alta calidad",
    ],
    categoriaTrabajo: "desatranques"
  },
  {
    id: "fontaneria",
    titulo: "Fontanería",
    descripcion: "Instalaciones y reparaciones de fontanería.",
    descripcionLarga: "Servicios completos de fontanería con más de 25 años de experiencia. Nuetsro equipo se encarga de todo tipo de instalaciones tanto averias como instalaciones nuevas de fontanería en viviendas, locales comerciales, etc.",
    imagen: "/imagenes/servicios/fontaneria.png",
    imagenHero: "https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=1200",
    serviciosIncluidos: [
      "Instalaciones completas en obra nueva",
      "Cambio de tuberías",
      "Detección y reparación de fugas",
      "Instalación de sanitarios y griferías",
      "Grupos de presión y bombas de agua",
      "Calderas y termos eléctricos",
      "Preintalación e instalación de equipos de depuracion",
      "Montaje de clorador salino"
    ],
    puntosClave: [
      "Trabajamos con multicapa, pvc, ppr, cobre",
      "Detección de fugas sin romper",
      "Materiales de primera calidad",
    ],
    categoriaTrabajo: "fontaneria"
  },
  {
    id: "electricidad",
    titulo: "Electricidad",
    descripcion: "Instalaciones eléctricas certificadas para hogares y empresas. Ahorro energético y máxima seguridad garantizada.",
    descripcionLarga: "En nuestro equipo contamos con electricistas titulados y autorizados para realizar todo tipo de instalaciones eléctricas, desde reformas hasta instalaciones nuevas.",
    imagen: "/imagenes/servicios/electricidad.png",
    imagenHero: "https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=1200",
    serviciosIncluidos: [
      "Instalaciones eléctricas completas",
      "Cuadros eléctricos",
      "Iluminación LED de bajo consumo",
      "Reparaciones de averías",
    ],
    puntosClave: [
      "Instaladores autorizados oficiales",
      "Seguridad en nuestras instalaciones",
      "Ahorro energético",
    ],
    categoriaTrabajo: "electricidad"
  },
  {
    id: "carpinteria-metalica",
    titulo: "Carpintería Metálica",
    descripcion: "Fabricacion e instalación de elementos de carpintería metálica",
    descripcionLarga: "Fabricación e instalación de carpintería de aluminio. Trabajamos con carpinterias con roturas de puente térmico para mejorar el aislamiento tanto acústico como térmico. Realizamos proyectos a medida adaptándonos a las necesidades de cada cliente.",
    imagen: "/imagenes/servicios/carpinteria_metalica.png",
    imagenHero: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1200",
    serviciosIncluidos: [
      "Puertas de seguridad",
      "Ventanas de aluminio con RPT",
      "Ventanas oscilobatientes",
      "Cerramientos",
      "Mosquiteras a medida"
    ],
    puntosClave: [
      "Fabricación propia",
      "Aislamiento térmico y acústico",
      "Proyectos a medida"
    ],
    categoriaTrabajo: "carpinteria"
  },
  {
    id: "aerotermia",
    titulo: "Aerotermia",
    descripcion: "Instalación de sistemas de aerotermia para climatización y agua caliente sanitaria.",
    descripcionLarga: "La aerotermia es uno de los sistemas más eficiente para climatizar tu hogar: proporciona calefacción en invierno, refrigeración en verano y agua caliente todo el año con un único equipo. Por ello es uno de nuestros trabajos demandados actualmente.",
    imagen: "/imagenes/servicios/foto_aerotermia.png",
    imagenHero: "https://images.unsplash.com/photo-1513694203232-719a280e022f?w=1200",
    serviciosIncluidos: [
      "Instalación completa de aerotermia",
      "Calefacción por suelo radiante",
      "Aire acondicionado por conductos",
      "Aislamiento térmico",
      "Bomba de calor aire-agua",
      "Bomba de calor aire-aire",
      "Agua caliente sanitaria (ACS)",
    ],
    puntosClave: [
      "Ahorro energético",
      "Energía 100% renovable",
    ],
    categoriaTrabajo: "aerotermia"
  },
  {
    id: "climatizacion",
    titulo: "Climatización",
    descripcion: "Instalación y mantenimiento de sistemas de climatización para un confort óptimo en tu hogar o negocio.",
    descripcionLarga: "Ofrecemos soluciones integrales de climatización adaptadas a tus necesidades. Trabajamos con las mejores marcas del mercado para garantizar eficiencia, durabilidad y confort. Nos encargamos de la instalación y mantenimiento de sistemas de aire acondicionado y calefacción.",
    imagen: "/imagenes/servicios/climatizacion.png",
    imagenHero: "https://images.unsplash.com/photo-1631545806609-3c480b5d7b0c?w=1200",
    serviciosIncluidos: [
      "Instalación completa",
      "Instalación de maquinas de aire acondicionado frío/calor",
      "Calefacción por radiadores",
      "Mantenimiento y reparaciones",
      "Termostatos inteligentes",
      "Certificaciones oficiales",
    ],
    puntosClave: [
      "Instaladores certificados oficiales",
      "Equipos de máxima eficiencia",
      "Ahorro energético",
    ],
    categoriaTrabajo: "climatizacion"
  },
  {
    id: "impermeabilizacion",
    titulo: "Impermeabilización",
    descripcion: "Soluciones definitivas contra humedades y filtraciones.",
    descripcionLarga: "Sistemas garantizados para cubiertas, terrazas y sótanos. Utilizamos materiales de alta calidad y técnicas avanzadas para asegurar la impermeabilización total de tus espacios, protegiendo tu inversión a largo plazo.",
    imagen: "/imagenes/servicios/impermeabilizacion.png",
    imagenHero: "https://images.unsplash.com/photo-1632823469850-2f77dd9c7f93?w=1200",
    serviciosIncluidos: [
      "Impermeabilización de cubiertas planas",
      "Terrazas y azoteas",
      "Sótanos y garajes",
      "Tratamiento de humedades",
      "Reparación de goteras",
      "Aislamiento térmico",
      "Sellado de juntas de dilatación",

    ],
    puntosClave: [
      "Materiales de alta durabilidad",
      "Sin necesidad de levantar suelos",
      "Protección a largo plazo"
    ],
    categoriaTrabajo: "impermeabilizacion"
  },
  {
    id: "piscinas",
    titulo: "Piscinas",
    descripcion: "Construcción y reforma de piscinas.",
    descripcionLarga: "Realizamos piscinas de obra completamente personalizadas, adaptadas a tu espacio y necesidades. Además hacemos reformas sobre piscinas ya construidas. También reformamos piscinas antiguas, actualizando sistemas y renovando revestimientos.",
    imagen: "/imagenes/servicios/piscinas.png",
    imagenHero: "https://images.unsplash.com/photo-1572331165267-854da2b021b1?w=1200",
    serviciosIncluidos: [
      "Construcción de piscinas de obra",
      "Mantenimiento y limpieza",
      "Revestimiento de piscinas",
      "Reparación de filtraciones",
      "Instalación de sistemas de depuración",
      "Reformas de piscinas existentes",
      "Venta de accesorios y productos químicos",
    ],
    puntosClave: [
      "Construcción a medida y desde cero",
      "Diseño a tu gusto",
      "Mantenimiento y limpieza",
    
    ],
    categoriaTrabajo: "piscina"
  },
  {
    id: "descalcificadores",
    titulo: "Descalcificadores y Ósmosis",
    descripcion: "Sistemas de tratamiento de agua para eliminar cal y mejorar la calidad. Protege tus instalaciones y tu salud.",
    descripcionLarga: "Ofrecemos soluciones integrales para el tratamiento del agua en tu hogar o negocio. Nuestros sistemas de descalcificación y ósmosis inversa garantizan agua pura, libre de cal y contaminantes, mejorando la calidad del agua para beber y proteger tus electrodomésticos.",
    imagen: "/imagenes/servicios/osmosis.png",
    imagenHero: "https://images.unsplash.com/photo-1548839140-29a749e1cf4d?w=1200",
    serviciosIncluidos: [
      "Descalcificadores de agua",
      "Ósmosis inversa 5 etapas",
      "Mantenimiento y recambios",
      "Reparación de equipos",
      "Instalación de sistemas"
    ],
    puntosClave: [
      "Eliminamos la cal",
      "Agua pura para beber",
      "Alargar la vida de los electrodomésticos",
    ],
    categoriaTrabajo: "fontaneria"
  }
];
